// 보상(급여) 도메인 라우트 - route.name = OBJECT_ID(LNB FRM_MENU 연결 키).
// 전 화면 placeholder(준비 중) - 퍼블리싱 시 pages/pay/{OBJECT_ID}.vue 내용만 교체(라우트 불변).
const payRoutes = [
  {
    path: 'pay/item-setting',
    name: 'PAY1010',
    component: () => import('@/pages/pay/PAY1010.vue'),
    meta: { requiresAuth: true, title: '급여 항목 설정', menuId: 'PAY1010', objInfo: 'PAY1010 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/type-setting',
    name: 'PAY1020',
    component: () => import('@/pages/pay/PAY1020.vue'),
    meta: { requiresAuth: true, title: '급여 유형 설정', menuId: 'PAY1020', objInfo: 'PAY1020 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/contract-table',
    name: 'PAY1030',
    component: () => import('@/pages/pay/PAY1030.vue'),
    meta: { requiresAuth: true, title: '계약 금액 테이블 기준', menuId: 'PAY1030', objInfo: 'PAY1030 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/nontax-target',
    name: 'PAY1040',
    component: () => import('@/pages/pay/PAY1040.vue'),
    meta: { requiresAuth: true, title: '비과세 및 감면 대상자', menuId: 'PAY1040', objInfo: 'PAY1040 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/emp-table',
    name: 'PAY1050',
    component: () => import('@/pages/pay/PAY1050.vue'),
    meta: { requiresAuth: true, title: '구성원 급여 테이블 관리', menuId: 'PAY1050', objInfo: 'PAY1050 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/paid-leave',
    name: 'PAY1060',
    component: () => import('@/pages/pay/PAY1060.vue'),
    meta: { requiresAuth: true, title: '유급 휴가 지급 관리', menuId: 'PAY1060', objInfo: 'PAY1060 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/tax-table',
    name: 'PAY1070',
    component: () => import('@/pages/pay/PAY1070.vue'),
    meta: { requiresAuth: true, title: '간이 세액 조견표', menuId: 'PAY1070', objInfo: 'PAY1070 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/result-setting',
    name: 'PAY1080',
    component: () => import('@/pages/pay/PAY1080.vue'),
    meta: { requiresAuth: true, title: '급여 결과 설정', menuId: 'PAY1080', objInfo: 'PAY1080 · 환경설정/급여 관리 (준비 중)' },
  },
  {
    path: 'pay/retire-info',
    name: 'PAY1110',
    component: () => import('@/pages/pay/PAY1110.vue'),
    meta: { requiresAuth: true, title: '퇴직금 관리 정보', menuId: 'PAY1110', objInfo: 'PAY1110 · 환경설정/퇴직금 관리 (준비 중)' },
  },
  {
    path: 'pay/retire-calc-setting',
    name: 'PAY1120',
    component: () => import('@/pages/pay/PAY1120.vue'),
    meta: { requiresAuth: true, title: '퇴직금 계산 설정', menuId: 'PAY1120', objInfo: 'PAY1120 · 환경설정/퇴직금 관리 (준비 중)' },
  },
  {
    path: 'pay/settle-days',
    name: 'PAY2010',
    component: () => import('@/pages/pay/PAY2010.vue'),
    meta: { requiresAuth: true, title: '급여일자 관리', menuId: 'PAY2010', objInfo: 'PAY2010 · 보상관리/급여 정산 (준비 중)' },
  },
  {
    path: 'pay/settle-targets',
    name: 'PAY2020',
    component: () => import('@/pages/pay/PAY2020.vue'),
    meta: { requiresAuth: true, title: '대상자 관리', menuId: 'PAY2020', objInfo: 'PAY2020 · 보상관리/급여 정산 (준비 중)' },
  },
  {
    path: 'pay/settle-exceptions',
    name: 'PAY2025',
    component: () => import('@/pages/pay/PAY2025.vue'),
    meta: { requiresAuth: true, title: '급여 예외사항 관리', menuId: 'PAY2025', objInfo: 'PAY2025 · 보상관리/급여 정산 (준비 중)' },
  },
  {
    path: 'pay/settle-basis-close',
    name: 'PAY2030',
    component: () => import('@/pages/pay/PAY2030.vue'),
    meta: { requiresAuth: true, title: '계산기초 마감', menuId: 'PAY2030', objInfo: 'PAY2030 · 보상관리/급여 정산 (준비 중)' },
  },
  {
    path: 'pay/settle-retro',
    name: 'PAY2040',
    component: () => import('@/pages/pay/PAY2040.vue'),
    meta: { requiresAuth: true, title: '소급 관리', menuId: 'PAY2040', objInfo: 'PAY2040 · 보상관리/급여 정산 (준비 중)' },
  },
  {
    path: 'pay/payroll-run',
    name: 'PAY2050',
    component: () => import('@/pages/pay/PAY2050.vue'),
    meta: { requiresAuth: true, title: '급여 계산', menuId: 'PAY2050', objInfo: 'PAY2050 · 보상관리/급여 정산 (준비 중)' },
  },
  {
    path: 'pay/settle-compare',
    name: 'PAY2060',
    component: () => import('@/pages/pay/PAY2060.vue'),
    meta: { requiresAuth: true, title: '지급 공제 비교', menuId: 'PAY2060', objInfo: 'PAY2060 · 보상관리/급여 정산 (준비 중)' },
  },
  {
    path: 'pay/result-ledger',
    name: 'PAY3010',
    component: () => import('@/pages/pay/PAY3010.vue'),
    meta: { requiresAuth: true, title: '급여 대장', menuId: 'PAY3010', objInfo: 'PAY3010 · 보상관리/급여 결과 (준비 중)' },
  },
  {
    path: 'pay/result-payslip',
    name: 'PAY3020',
    component: () => import('@/pages/pay/PAY3020.vue'),
    meta: { requiresAuth: true, title: '급여 명세서', menuId: 'PAY3020', objInfo: 'PAY3020 · 보상관리/급여 결과 (준비 중)' },
  },
  {
    path: 'pay/result-history',
    name: 'PAY3030',
    component: () => import('@/pages/pay/PAY3030.vue'),
    meta: { requiresAuth: true, title: '지급 내역 조회', menuId: 'PAY3030', objInfo: 'PAY3030 · 보상관리/급여 결과 (준비 중)' },
  },
  {
    path: 'pay/result-notify',
    name: 'PAY3040',
    component: () => import('@/pages/pay/PAY3040.vue'),
    meta: { requiresAuth: true, title: '급여 알림 발송', menuId: 'PAY3040', objInfo: 'PAY3040 · 보상관리/급여 결과 (준비 중)' },
  },
  {
    path: 'pay/retire-targets',
    name: 'PAY4010',
    component: () => import('@/pages/pay/PAY4010.vue'),
    meta: { requiresAuth: true, title: '퇴직금 대상자 관리', menuId: 'PAY4010', objInfo: 'PAY4010 · 보상관리/퇴직금 관리 (준비 중)' },
  },
  {
    path: 'pay/retire-calc',
    name: 'PAY4020',
    component: () => import('@/pages/pay/PAY4020.vue'),
    meta: { requiresAuth: true, title: '퇴직금 계산', menuId: 'PAY4020', objInfo: 'PAY4020 · 보상관리/퇴직금 관리 (준비 중)' },
  },
  {
    path: 'pay/retire-payments',
    name: 'PAY4030',
    component: () => import('@/pages/pay/PAY4030.vue'),
    meta: { requiresAuth: true, title: '퇴직금 지급 내역', menuId: 'PAY4030', objInfo: 'PAY4030 · 보상관리/퇴직금 관리 (준비 중)' },
  },
  {
    path: 'pay/retire-tax-defer',
    name: 'PAY4040',
    component: () => import('@/pages/pay/PAY4040.vue'),
    meta: { requiresAuth: true, title: '과세이연 정보 관리', menuId: 'PAY4040', objInfo: 'PAY4040 · 보상관리/퇴직금 관리 (준비 중)' },
  },
  {
    path: 'pay/retire-docs',
    name: 'PAY4050',
    component: () => import('@/pages/pay/PAY4050.vue'),
    meta: { requiresAuth: true, title: '퇴직금 자료', menuId: 'PAY4050', objInfo: 'PAY4050 · 보상관리/퇴직금 관리 (준비 중)' },
  },
  {
    path: 'pay/retire-dc',
    name: 'PAY4060',
    component: () => import('@/pages/pay/PAY4060.vue'),
    meta: { requiresAuth: true, title: 'DC 부담금 관리', menuId: 'PAY4060', objInfo: 'PAY4060 · 보상관리/퇴직금 관리 (준비 중)' },
  },
];

export default payRoutes;
